import React, { useEffect } from "react";
import { PageProps } from "@sdflc/react-router-pages";
import { FullScreenLayout } from "@/components/layouts/FullScreenLayout";
import { TVActivationFlow } from "@/components/features/TVActivationFlow";
import { SignalRProvider } from "@/contexts";

export const TvPage: React.FC<PageProps> = (props: PageProps) => {
  useEffect(() => {
    const html = document.querySelector("html");

    if (html && html.classList.contains("tv") == false) {
      html.classList.add("tv");
    }

    const wakeLock = async () => {
      if ("wakeLock" in navigator) {
        try {
          await navigator.wakeLock.request("screen");
          console.log("Wake Lock active");
        } catch (err) {
          console.error("Wake Lock error:", err);
        }
      }
    };

    wakeLock();

    // Fallback ping every minute
    const intervalId = setInterval(
      () => console.log("Keep screen awake"),
      60000
    );

    return () => {
      // Cleanup: remove the tv class and meta tag when component unmounts
      if (html) {
        html.classList.remove("tv");
      }

      clearInterval(intervalId);
    };
  }, []);

  return (
    <SignalRProvider
      options={{
        autoConnect: true,
        debug: import.meta.env.VITE_ENVIRONMENT != "production", // Enable debug in development
        minUpdateDelay: 0,
        maxUpdateDelay: 5000, // 30 seconds
      }}
    >
      <FullScreenLayout {...props}>
        <TVActivationFlow />
      </FullScreenLayout>
    </SignalRProvider>
  );
};
